module.exports = __webpack_public_path__ + "img/stock3.1c52b288.png";